class ClientFilterIndexes {  
  constructor(filterForm) {
    this.groupsById = new Map();
    
    this.fieldsById = new Map();

    this.fieldsByGroupId = new Map();

    this.fieldValueIdsByFieldId = new Map();

    this.fieldValueLookupById = new Map();

    this.childFieldsByParentFieldId = new Map();

    this.parentFieldsByChildFieldId = new Map();

    this.childValueIdsByParentValueAndField = new Map();

    this.build(filterForm);
  }

  build(filterForm) {
    const {
      filterGroups,
      filterFields,
      currentFilterValues,
      parentChildValues,
      childParentFilters,
    } = filterForm;
    
    // Filter Groups Index
    filterGroups.forEach((g) => {
      this.groupsById.set(g.profileGroupId, g);
    });

    // Filter Fields Index
    filterFields.forEach((f) => {
      this.fieldsById.set(f.setFieldId, f);

      if (!this.fieldsByGroupId.has(f.profileGroupId)) {
        this.fieldsByGroupId.set(f.profileGroupId, []);
      }

      this.fieldsByGroupId.get(f.profileGroupId).push(f);
    });

    // Field values Index
    parentChildValues.forEach((pc) => {
      const childFieldId = pc.childSetFieldId;
      const childFieldValueId = pc.childSetFieldValueId;
      const { childFieldValue } = pc;

      // field value lookup map
      if (!this.fieldValueLookupById.has(childFieldValueId)) {
        this.fieldValueLookupById.set(childFieldValueId, {
          setFieldId: childFieldId,
          setFieldValueId: childFieldValueId,
          fieldValue: childFieldValue,
          primaryId: pc.primaryId,
        });
      }

      // field -> fieldValues map
      if (!this.fieldValueIdsByFieldId.has(childFieldId)) {
        this.fieldValueIdsByFieldId.set(childFieldId, []);
      }
      this.fieldValueIdsByFieldId.get(childFieldId).push(childFieldValueId);

      // parent-child value relationship
      if (pc.parentSetFieldValueId) {
        if (!this.childValueIdsByParentValueAndField.has(pc.parentSetFieldValueId)) {
          this.childValueIdsByParentValueAndField.set(pc.parentSetFieldValueId, new Map());
        }
        const fieldMap = this.childValueIdsByParentValueAndField.get(pc.parentSetFieldValueId);
        if (!fieldMap.has(childFieldId)) {
          fieldMap.set(childFieldId, new Set());
        }
        fieldMap.get(childFieldId).add(childFieldValueId);
        // this.childValueIdsByParentValueId.get(pc.parentSetFieldValueId).push(childFieldValueId);
      }
    });

    // Field dependency Index
    childParentFilters.forEach((rel) => {
      const parentFieldId = rel.parentSetFieldId;
      const childFieldId = rel.childSetFieldId;

      if (!this.childFieldsByParentFieldId.has(parentFieldId)) {
        this.childFieldsByParentFieldId.set(parentFieldId, []);
      }
      this.childFieldsByParentFieldId.get(parentFieldId).push(childFieldId);

      if (!this.parentFieldsByChildFieldId.has(childFieldId)) {
        this.parentFieldsByChildFieldId.set(childFieldId, []);
      }
      this.parentFieldsByChildFieldId.get(childFieldId).push(parentFieldId);
    });

    this.fieldValueIdsByFieldId.forEach((_, fieldId) => {
      this.sortFieldValues(fieldId);
    });

    // currentFilterValues.forEach((v) => {
    //   this.valueById.set(v.setFieldValueId, v);

    //   if (!this.valuesByField.has(v.setFieldId)) {
    //     this.valuesByField.set(v.setFieldId, []);
    //   }

    //   this.valuesByField.get(v.setFieldId).push(v);
    // });
  }

  sortFieldValues(fieldId) {
    const field = this.fieldsById.get(fieldId);
    const fieldValueIds = this.fieldValueIdsByFieldId.get(fieldId);
    const isYearField = field?.fieldCode === 'lg01_award_year';

    if (!fieldValueIds) {
      return;
    }

    const fieldValues = fieldValueIds.map((id) => this.fieldValueLookupById.get(id));
    const isNumeric = field?.primitiveType === 'int' || field?.primitiveType === 'number';

    fieldValues.sort((a, b) => {
      if (isNumeric) {
        return Number(b.fieldValue) - Number(a.fieldValue);
      }
      if (isYearField) {
        return Number(b.fieldValue) - Number(a.fieldValue);
      }
      return a.fieldValue.localeCompare(b.fieldValue);
    });

    this.fieldValueIdsByFieldId.set(fieldId, fieldValues.map((v) => v.setFieldValueId));
  }
}

export default ClientFilterIndexes;
